import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';

export default class FMPText extends Component {
	render () {
		const { label, path, controller, contained, helpText, multiline, md, disabled } = this.props;


		const { state } = controller;
		const { formFieldError } = state;

		if (!_.isFunction(controller.onChange)) {
			console.error('Controller missing handle change');
			return;
		}

		if (!_.isObject(formFieldError)) {
			console.error('Controller missing formFieldError object');
			return;
		}

		//let value, onChange, error;
		const value = _.get(state, path, '');
		const error = _.get(formFieldError, path);
		const hasError = !!error;
		const onChange = event => controller.onChange(event, path);

		const content = (
			<Grid item xs={12} md={md} style={{margin:'5px 0px'}}>
				<FormControl fullWidth={true} error={hasError} disabled={disabled}>

					{!multiline &&
					<TextField
						error={hasError}
						disabled={disabled}
						value={value}
						onChange={onChange}
						label={label}
						fullWidth
					/>}

					{multiline &&
					<TextField
						error={hasError}
						disabled={disabled}
						value={value}
						onChange={onChange}
						label={label}
						multiline
						rows={multiline}
						fullWidth
					/>}

					{hasError && <FormHelperText>{error}</FormHelperText>}
					{(helpText && !hasError) && <FormHelperText>{helpText}</FormHelperText>}
				</FormControl>
			</Grid>
		);

		if (contained) {
			return (
				<Grid spacing={2} container>
					{content}
				</Grid>
			);
		} else {
			return content;
		}
	}
}

FMPText.propTypes = {
	label : PropTypes.string,
	path: PropTypes.array.isRequired,
	controller: PropTypes.object.isRequired,
	helpText : PropTypes.string,
	contained : PropTypes.bool,
	multiline: PropTypes.number,
	md : PropTypes.number,
	disabled : PropTypes.bool,
};

FMPText.defaultProps = {
	contained : true,
	md : 12,
};